import { FeatureAppLoader } from "@feature-hub/react";
import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { CustomFeatureAppConfig } from "../../app/src";

export const App: React.FC<{
  baseUrl?: string;
  featureAppConfig?: CustomFeatureAppConfig;
}> = ({ baseUrl, featureAppConfig }) => {
  return (
    <div>
      <GlobalStyle />

      <MockAdacHeader>
        <h2>ADAC</h2>
      </MockAdacHeader>

      <StyledBody>
        <FeatureAppLoader
          baseUrl={baseUrl}
          featureAppId="adac:feature-app:example"
          src={getFeatureAppAssets("/maut-hungary.client.js")}
          // serverSrc={getFeatureAppAssets("/maut-hungary.ssr.js")}
          css={[
            {
              href: getFeatureAppAssets("/adac-styles.css"),
              media: "all",
            },
          ]}
          config={featureAppConfig}
        />
      </StyledBody>

      <MockAdacFooter>
        <span>©2025 ADAC</span>
      </MockAdacFooter>
    </div>
  );
};

/**
 * Returns the URL for the feature app assets.
 * This makes sure it uses the local server (with hot refresh) in development mode
 */
function getFeatureAppAssets(path: string) {
  const baseUrl = process.env.FEATURE_APP_BASE_URL || "/maut-hungary";
  return `${baseUrl}${path}`;
}

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    background: rgba(255, 255, 255, 1);
  }
`;

const MockAdacHeader = styled.div`
  height: 64px;
  background-color: rgb(255, 204, 0);
  padding: 1em;

  font-family: ADACSans, Arial, sans-serif;
  font-feature-settings: "lnum";
`;

const StyledBody = styled.div`
  min-height: calc(100vh - 244px);
  padding: 32px 8px;

  @media (min-width: 1280px) {
    padding-inline: 16px;
  }

  @media (min-width: 1280px) {
    padding: 64px 0px;
  }
`;

const MockAdacFooter = styled.div`
  height: 180px;
  width: 100%;
  padding: 1em;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  text-align: center;

  font-family: ADACSans, Arial, sans-serif;
  font-feature-settings: "lnum";
`;
